module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABH0lEQVRIS+2UMU7DQBBF31iKcwIOQEuDkKChMoeAkgq8UFBwAsQFqFLEISlo4RC4oQMJCYmWA3ACNrCDkGXjOIm9shKBEG68Ws+8P/M9u8ISH1kim18C79t1hEcCNjkMH3w69q88sXfANnCPCbcWB0/sBXBaAIU+cXjcJNBc+eX7Ps5dgb6ArBZv5YCjcFQnUA8f2g0+6KHaI5AYJUJIcTpA5ATUYLpP8wSaK88zB/a2gMfhTpMlX9+n4cnbLgRr38kuW4pEBVw1zTaDkoZ7xnRvyqLT8LzCyagMltuSr6sxlY7+EjwZnyEazfxhZVuqASoppnNe7/m8MVjItPzDZx6iH7ElGV8juoLKK6az1+74+2R5xvhfXJ7AdnPeAv4Jaxp3GAL2+okAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/maptool/draw/szzbz.png
// module id = HHsi
// module chunks = 35